import {ConfigService} from '../../modules/ConfigModule';
import {SpinnerService} from '../../modules/SpinnerModule';
import {ngStorage} from 'ngstorage';

export default class LoginController {
    model = {
        username: null,
        password: null,
    };
    error = null;
    logins = null;

    constructor(
        $scope: ng.IScope,
        private $http: ng.IHttpService,
        private $localStorage: ngStorage.StorageService,
        private $config: ConfigService,
        private $spinner: SpinnerService) {

        let url = $config.apiBase + 'auth/ExternalLogins?returnUrl=' + window.location.href;
        $http.get(url)
            .then(result => {
                this.logins = result.data;
            })

        $spinner.hide();
    }


    login = () => {
        this.$spinner.show('Checking login...');
        this.$config.login(this.model.username, this.model.password)
            .catch(e => {
                console.log('login error', e);
                this.error = e;
            })
            .finally(() => this.$spinner.hide());
    }

    get baseUrl() {
        try {
            let url = new URL(this.$config.apiBase);
            return url.protocol + "//" + url.host;
        } catch {
            return ''
        }
    }
}
